import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagsAlert = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tags-alert" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.189,
			y1: 4.124,
			x2: 16.189,
			y2: 4.124
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.939,
			y1: 20.249,
			x2: 16.939,
			y2: 20.249
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.939,20.249a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.939,
			y1: 17.999,
			x2: 16.939,
			y2: 14.999
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.752,20.681a1.774,1.774,0,0,1-1.587,2.568H12.713a1.773,1.773,0,0,1-1.586-2.568l4.225-8.451a1.774,1.774,0,0,1,3.174,0Z"
		})
	]
});
export default SvgTagsAlert;
